import { ROUTE_CONST } from "~/route/const";
import { _ } from "~/i18n";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";

export function criterionToTypeIcon(criterion: number): string {
	const types = Object.keys(ROUTE_CONST.types);

	for (let index = 0; index < types.length; index++) {
		const indexCriterion = (ROUTE_CONST.types[types[index]].criterion as Array<number>).indexOf(criterion);

		if (indexCriterion !== -1) {
			return ROUTE_CONST.types[types[index]].svg;
		}
	}

	return "";
}

export function getRouteSubtitle(totalLength, totalTime) {
	const distance = standardDistanceFormat(totalLength);
	const formatTime = standardTimeFormat(parseInt(totalTime), true);

	return _("route.result.route", `${distance.distance} ${distance.unit} • ${formatTime.time} ${formatTime.unit}`);
}

export function getCriterion() {
	const routeState = Mapy.CML.state.route;
	const items = routeState.items;

	return items.length === 1 && items[0]?.planTrip ? routeState.params.tripCriterion : routeState.params.criterion;
}
